import { render, staticRenderFns } from "./ItemData.vue?vue&type=template&id=65f36e44&scoped=true&"
import script from "./ItemData.vue?vue&type=script&lang=ts&"
export * from "./ItemData.vue?vue&type=script&lang=ts&"
import style0 from "./ItemData.vue?vue&type=style&index=0&id=65f36e44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f36e44",
  null
  
)

export default component.exports